export enum PosthogFeatureFlags {
  TWO_MONTHS_PROP = '2-month-purchase-date-prop-mar-26',
  QUOTE_PAGE_EXPERIMENT = 'quote-page-experiment-apr-26',
  // This is the feature flag for the QR code registration source that will be used for the new QR code registration source test.
  DANDG_QR_CODE = 'dandg-qr-code-may-26',
  LANDING_PAGE = 'landing-page-may-2026',
}
